import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=b71e9a5e&scoped=true&"
import script from "./DistributorList.vue?vue&type=script&lang=js&"
export * from "./DistributorList.vue?vue&type=script&lang=js&"
import style0 from "./DistributorList.vue?vue&type=style&index=0&id=b71e9a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71e9a5e",
  null
  
)

export default component.exports